import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { DocumentoTipo } from '../models/documento-tipo.model';

@Injectable()
export class DocumentoTipoService extends BaseService<DocumentoTipo> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/documento-tipo';
  }

  

}
